var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-card" }, [
    _vm.showTitle
      ? _c("div", { staticClass: "card-title", style: _vm.titleStyle }, [
          _c("div", { staticClass: "card-title-div" }, [_vm._t("title")], 2)
        ])
      : _vm._e(),
    _vm.showTitle ? _c("div", { staticClass: "van-hairline--top" }) : _vm._e(),
    _c(
      "div",
      {
        staticClass: "card-content",
        style: { paddingTop: _vm.paddingTop ? _vm.paddingTop : "" }
      },
      [_vm._t("content")],
      2
    ),
    _vm.showFooter
      ? _c(
          "div",
          { staticClass: "card-footer" },
          [
            _c("div", { staticClass: "mobile-card-line van-hairline--top" }),
            _vm._t("footer")
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }